var Modernizr = require('../../vendors/modernizr.min');
var $ = require('jquery');
require('jquery-hoverintent');
var _debounce = require('lodash/debounce');
var WS = require('../../scripts/ws.js');
var Dialog = require("./dialog");
var SiteMask = require('./site-mask');

let executed = false;
let intervalId;
const $body = $('body');
const $nav = $('.ws-nav');
const $utilityNav = $('.ws-nav__utility-nav');
const $mainNav = $('.ws-nav__main');
const mobileMenuBtn = document.querySelector('.ws-nav__mobile-menu-btn');
const $mobileMenuBtn = $(mobileMenuBtn);

function toggleMobileMenu(event) {
    $mobileMenuBtn.toggleClass('ws-nav__mobile-menu-btn--close');
    $utilityNav.toggleClass('ws-nav__utility-nav--open');
    $mainNav.toggleClass('ws-nav__main--open');
    $body.toggleClass('ws-body--mobile-nav-open');

    if ($body.hasClass('ws-body--mobile-nav-open')) {
        Dialog.openDialog($nav, event, null, '');
        $(".ws-nav__mobile-menu-btn--close").focus();
    }
    else if ($('.ws-chat-dialog').hasClass('ws-dialog--enabled')) {
        Dialog.closeDialog(event);
        $(".ws-nav__mobile-menu-btn").focus();
    }
    else {
        Dialog.closeAllDialogs(event);
        $(".ws-nav__mobile-menu-btn").focus();
    }
}

function initNav() {
    var desktopMq = '(min-width: 992px)';
    var primaryLinkSelectedClass = 'ws-nav__primary-link-wrapper--selected';
    var sectionLinkSelectedClass = 'ws-nav__section-link-wrapper--selected';
    var mobilePageClass = 'ws-nav__mobile-page';
    var mobilePageClassSelector = '.' + mobilePageClass;
    var mobilePageOnScreenClass = 'ws-nav__mobile-page--on-screen';
    var mobilePageOnScreenCompleteClass = 'ws-nav__mobile-page--on-screen-complete';
    var mobilePageOffScreenLeftClass = 'ws-nav__mobile-page--off-screen-left';

    var $window = $(window);
    var $document = $(document);
    var $skipLinks = $('.ws-skip-link');
    var $segmentationDropdown = $('.ws-nav__segmentation > select');
    var $primaryLinks = $('.ws-nav__primary-links > li');
    var $touchPrimaryLinks = $('.ws-nav__primary-link');
    var $sectionLinks = $('.ws-nav__section-links > li');
    var $touchSectionLinks = $('.ws-nav__section-link-wrapper--has-children > .ws-nav__section-link');
    var $sectionLinkTags = $('.ws-nav__section-link');
    var $subSectionLinks = $('.ws-nav__sub-section-link');
    var $sectionHeadingLinks = $('.ws-nav__section-heading-link');
    var $sectionInfoLinks = $('.ws-nav__section-info-link');

    var $mobilePageLinks = $('.ws-nav__mobile-page-link');
    var $mobileBackLinks = $('.ws-nav__mobile-back-link');
    var $mobilePrimaryLinks = $('.ws-nav__primary-link.ws-nav__mobile-page-link, #ws-primary-nav__select');
    var $mobileSecondaryLevelLinks = $('.ws-nav__secondary-level-link');
    var $mobileThirdLevelLinks = $('.ws-nav__third-level-link');

    function mobileLinkTabOrder() {
        if (!Modernizr.mq(desktopMq)) {
            closeMegaMenu();
            $mobilePrimaryLinks.attr("tabindex", "");
            $mobileSecondaryLevelLinks.attr("tabindex", -1);
            $mobileThirdLevelLinks.attr("tabindex", -1);
        } else {
            $mobileBackLinks.attr("tabindex", "");
            $mobileSecondaryLevelLinks.attr("tabindex", "");
            $mobileThirdLevelLinks.attr("tabindex", "");
        }
    }
    
    mobileLinkTabOrder();
    $window.resize(function () { mobileLinkTabOrder(); });

    $segmentationDropdown.on('change keydown', function (event) {
        if ($body.hasClass("ws-click") || event.which === 13) {
            document.location = $segmentationDropdown.val();
        }
    });

    if (Modernizr.browsertouch) {
        $touchPrimaryLinks.on('click', function (event) {
            if (Modernizr.mq(desktopMq)) {
                var $target = $(event.currentTarget),
                    $li = $target.parent();

                event.preventDefault();
                event.stopPropagation();

                if (!$li.hasClass(primaryLinkSelectedClass)) {
                    openMegaMenu($li);
                    $document.on('click', clickOutsideMenuHandler);
                } else {
                    closeMegaMenu();
                }
            }
        });

        $touchSectionLinks.on('click', function (event) {
            if (Modernizr.mq(desktopMq)) {
                var $target = $(event.currentTarget),
                    $li = $target.parent();

                if (!$li.hasClass(sectionLinkSelectedClass)) {
                    event.preventDefault();
                    event.stopPropagation();

                    $sectionLinks.removeClass(sectionLinkSelectedClass);
                    $li.addClass(sectionLinkSelectedClass);
                }
            }
        });
    } else {
        $primaryLinks.hoverIntent({
            over: function (event) {
                if (Modernizr.mq(desktopMq)) {
                    openMegaMenu($(event.currentTarget));
                }
            },
            out: function (event) {
                if (Modernizr.mq(desktopMq)) {
                    if ($(event.currentTarget).hasClass(primaryLinkSelectedClass)) {
                        closeMegaMenu();
                    }
                }
            },
            timeout: 500
        });

        $sectionLinks
            .on('mouseover', function (event) {
                if (Modernizr.mq(desktopMq)) {
                    $sectionLinks.removeClass(sectionLinkSelectedClass);
                    $(event.currentTarget).addClass(sectionLinkSelectedClass);
                }
            })
            .hoverIntent({
                over: function (event) { },
                out: function (event) {
                    if (Modernizr.mq(desktopMq)) {
                        $(event.currentTarget).removeClass(sectionLinkSelectedClass);
                    }
                },
                timeout: 500
            });
    }

    $mobileMenuBtn.on('click', function (event) {
        event.preventDefault();
        toggleMobileMenu(event);
    });

    $mobilePageLinks.on('click keydown', function (event) {
        if (event.which === 9 || event.shiftKey || event.altKey) {
            return;
        }

        if (!Modernizr.mq(desktopMq)) {
            var $target = $(event.currentTarget),
                $currentPage = $target.closest(mobilePageClassSelector),
                $nextPage = $target.siblings(mobilePageClassSelector).first();

            event.preventDefault();

            $currentPage
                .removeClass(mobilePageOnScreenClass)
                .removeClass(mobilePageOnScreenCompleteClass)
                .addClass(mobilePageOffScreenLeftClass);
            $nextPage
                .on(WS.getTransitionEndEventName(), mobileOnScreenTransitionEnd)
                .addClass(mobilePageOnScreenClass);
            $nextPage.find('button.ws-nav__mobile-back-link').first().focus();
        }
    });

    $mobileBackLinks.on('click keydown', function (event) {
        if (event.which === 9 || event.shiftKey || event.altKey) {
            return;
        }

        var $target = $(event.currentTarget),
            $currentPage = $target.closest(mobilePageClassSelector),
            $previousPage = $currentPage.parent().closest(mobilePageClassSelector);

        event.preventDefault();

        $currentPage
            .removeClass(mobilePageOnScreenClass)
            .removeClass(mobilePageOnScreenCompleteClass);
        $previousPage
            .on(WS.getTransitionEndEventName(), mobileOnScreenTransitionEnd)
            .removeClass(mobilePageOffScreenLeftClass)
            .addClass(mobilePageOnScreenClass);
        if ($previousPage.hasClass("ws-nav__main")) {
            $previousPage.find('a.ws-nav__primary-link-wrapper--selected').focus();
        } else {
            $previousPage.find('button.ws-nav__mobile-back-link').first().focus();
        }
    });

    $window.on('resize', _debounce(function (event) {
        if (Modernizr.mq(desktopMq) && $body.hasClass('ws-body--mobile-nav-open')) {
            toggleMobileMenu(event);
        }
    }, 200));

    $skipLinks.on('click', function (event) {
        event.preventDefault();
        var $target = $($(this).attr('href'));

        if (!Modernizr.mq(desktopMq) && $target.parents(".ws-nav__main").length) {
            $mobileMenuBtn.click();
        }

        if (!$target.attr('tabindex')) {
            $target.attr('tabindex', '0');
        }

        $target.focus();
    });

    /* --- START: HEADER KEYBOARD ACCESSIBILITY --- */

    function escapeMegaMenu($focusedItem, e) {
        e.preventDefault();
        $focusedItem.closest('li.ws-nav__primary-link-wrapper--selected').find('a.ws-nav__primary-link').focus();
        setTimeout(closeMegaMenu, 0);
    }

    function clickLink($focusedItem) {
        if (navigator.userAgent.indexOf('Chrome') > -1) {
            $focusedItem.trigger("keydown");
        } else {
            //FF and IE
            $focusedItem.trigger("click");
        }
    }

    $touchPrimaryLinks.focus(function (event) {
        if ($body.hasClass("ws-click")) {
            return;
        }

        $sectionLinks.removeClass(sectionLinkSelectedClass);
        var $target = $(event.currentTarget),
            $li = $target.parent();
        if (!$li.hasClass(primaryLinkSelectedClass)) {
            openMegaMenu($li);
        }
    });

    $('.ws-nav__section-link').focus(function (event) {
        if ($body.hasClass("ws-click")) {
            return;
        }

        $sectionLinks.removeClass(sectionLinkSelectedClass);
        var $target = $(event.currentTarget),
            $li = $target.parent();
        if ($li.hasClass('ws-nav__section-link-wrapper--has-children')) {
            $li.addClass(sectionLinkSelectedClass);
        }
    });

    document.addEventListener('focus', function (event) {
        if ($primaryLinks.hasClass(primaryLinkSelectedClass) && !$.contains($mainNav.get(0), event.target)) {
            closeMegaMenu();
        }
    }, true);

    $touchPrimaryLinks.on('keydown', function (e) {
        if (e.shiftKey || e.altKey) {
            return;
        }

        var $focusedItem = $(e.currentTarget);
        switch (e.which) {
            case 40:
                //down arrow
                e.preventDefault();
                openMegaMenu($focusedItem.parent());
                $focusedItem.parent().find('a.ws-heading').focus();
                break;
            case 37:
                //left arrow
                e.preventDefault();
                $focusedItem.closest('li').prev().find('a.ws-nav__primary-link').focus();
                break;
            case 39:
                //right arrow
                e.preventDefault();
                $focusedItem.closest('li').next().find('a.ws-nav__primary-link').focus();
                break;
            case 32:
                //spacebar
                e.preventDefault();
                if (e.which === 32) {
                    if (!$primaryLinks.hasClass(primaryLinkSelectedClass)) {
                        openMegaMenu($focusedItem.parent());
                    } else {
                        closeMegaMenu();
                    }
                }

                break;
            case 27:
                //escape
                escapeMegaMenu($focusedItem, e);
                break;
            case 13:
                //enter
                if (!Modernizr.mq(desktopMq)) {
                    var $linksUnderParent = $focusedItem.siblings().find('a.ws-nav__secondary-level-link, button.ws-nav__secondary-level-link');
                    $linksUnderParent.attr("tabindex", "");
                    $mobilePrimaryLinks.attr("tabindex", -1);
                    $mobileThirdLevelLinks.attr("tabindex", -1);
                    clickLink($focusedItem);

                    //$focusedItem.siblings().first("button.ws-nav__mobile-back-link").attr("tabindex", "").focus();
                }

                break;
            default:
                break;
        }
    });

    $sectionHeadingLinks.on('keydown', function (e) {
        if (e.shiftKey || e.altKey) {
            return;
        }

        var $focusedItem = $(e.currentTarget);
        switch (e.which) {
            case 38:
                //up arrow
                e.preventDefault();
                $focusedItem.closest('li').find('a.ws-nav__primary-link').first().focus();
                break;
            case 40:
                //down arrow
                e.preventDefault();
                $focusedItem.parent().find('a.ws-nav__section-info-link').focus();
                break;
            case 37:
                //left arrow
                e.preventDefault();
                $focusedItem.closest('li').find('a.ws-nav__primary-link').focus();
                break;
            case 39:
                //right arrow
                e.preventDefault();
                $focusedItem.closest('li').find('a.ws-nav__section-link').first().focus();
                break;
            case 27:
                //escape
                escapeMegaMenu($focusedItem, e);
                break;
            default:
                break;
        }
    });

    $sectionInfoLinks.on('keydown', function (e) {
        if (e.shiftKey || e.altKey) {
            return;
        }

        var $focusedItem = $(e.currentTarget);
        switch (e.which) {
            case 38:
                //up arrow
                e.preventDefault();
                $focusedItem.closest('div').find('a.ws-nav__section-heading-link').focus();
                break;
            case 40:
                //down arrow
                e.preventDefault();
                if ($focusedItem.closest('li').find('a.ws-nav__section-link').first().length) {
                    $focusedItem.closest('li').find('a.ws-nav__section-link').first().focus();
                } else {
                    $focusedItem.closest('li').next().find('a.ws-nav__primary-link').focus();
                }

                break;
            case 37:
                //left arrow
                e.preventDefault();
                $focusedItem.closest('li').find('a.ws-nav__primary-link').focus();
                break;
            case 39:
                //right arrow
                e.preventDefault();
                $focusedItem.closest('li').find('a.ws-nav__section-link').first().focus();
                break;
            case 27:
                //escape
                escapeMegaMenu($focusedItem, e);
                break;
            default:
                break;
        }
    });

    $sectionLinkTags.on('keydown', function (e) {
        if (e.shiftKey || e.altKey) {
            return;
        }

        var $focusedItem = $(e.currentTarget);
        switch (e.which) {
            case 38:
                //up arrow
                e.preventDefault();
                var $previousElement = $focusedItem.closest('li').prev();
                if ($previousElement.length) {
                    $previousElement.find('a.ws-nav__section-link').focus();
                } else {
                    $focusedItem.closest('li.ws-nav__primary-link-wrapper--selected').find('a.ws-nav__primary-link').focus();
                }

                break;
            case 40:
                //down arrow
                e.preventDefault();
                var $nextElement = $focusedItem.closest('li').next();
                if ($nextElement.length) {
                    $nextElement.find('a.ws-nav__section-link').focus();
                } else if (!$nextElement.length &&
                    $focusedItem.parent().hasClass('ws-nav__section-link-wrapper--has-children')) {
                    $focusedItem.closest('li.ws-nav__section-link-wrapper--selected').find('a.ws-nav__sub-section-link').first().focus();
                } else {
                    $focusedItem.closest('li.ws-nav__primary-link-wrapper--selected').next().find('a.ws-nav__primary-link').focus();
                }

                break;
            case 37:
                //left arrow
                e.preventDefault();
                $focusedItem.closest('div.ws-nav__section-nav').find('a.ws-nav__section-heading-link').focus();
                break;
            case 39:
                //right arrow
                e.preventDefault();
                if ($focusedItem.parent().hasClass('ws-nav__section-link-wrapper--has-children')) {
                    $focusedItem.closest('li.ws-nav__section-link-wrapper--selected').find('a.ws-nav__sub-section-link').first().focus();
                } else {
                    $focusedItem.closest('li.ws-nav__primary-link-wrapper--selected').find('a.ws-nav__primary-link').focus();
                }

                break;
            case 27:
                //escape
                escapeMegaMenu($focusedItem, e);
                break;
            default:
                break;
        }
    });

    $subSectionLinks.on('keydown', function (e) {
        if (e.shiftKey || e.altKey) {
            return;
        }

        var $focusedItem = $(e.currentTarget);
        switch (e.which) {
            case 38:
                //up arrow
                e.preventDefault();
                var $previousElement = $focusedItem.closest('li').prev();
                if ($previousElement.length) {
                    $previousElement.find('a.ws-nav__sub-section-link').focus();
                } else {
                    $focusedItem.closest('li.ws-nav__section-link-wrapper--has-children').find('a.ws-nav__section-link').focus();
                }

                break;
            case 40:
                //down arrow
                e.preventDefault();
                var $nextElement = $focusedItem.closest('li').next();
                if ($nextElement.length) {
                    $nextElement.find('a.ws-nav__sub-section-link').focus();
                } else {
                    $focusedItem.closest('li.ws-nav__primary-link-wrapper--selected').next().find('a.ws-nav__primary-link').focus();
                }

                break;
            case 37:
                //left arrow
                e.preventDefault();
                $focusedItem.closest('li.ws-nav__section-link-wrapper--has-children').find('a.ws-nav__section-link').focus();
                break;
            case 39:
                //right arrow
                e.preventDefault();
                $focusedItem.closest('li.ws-nav__primary-link-wrapper--selected').next().find('a.ws-nav__primary-link').focus();
                break;
            case 27:
                //escape
                escapeMegaMenu($focusedItem, e);
                break;
            default:
                break;
        }
    });

    $mobileSecondaryLevelLinks.on('keydown', function (e) {
        if (!Modernizr.mq(desktopMq)) {
            var $focusedItem = $(e.currentTarget);
            if (e.shiftKey && e.key === 'Tab') {
                //shift+tab
                if ($focusedItem.parent("li").is($focusedItem.closest("ul").children().first())) {
                    e.preventDefault();
                    $focusedItem.closest(".ws-nav__mobile-page-inner").find("a.ws-heading").first().focus();
                    return;
                } else if ($focusedItem.hasClass("ws-action-link")) {
                    e.preventDefault();
                    $focusedItem.closest(".ws-nav__mobile-page-inner").find("ul").first().children(":last-child").children("a").focus();
                    return;
                }

                return;
            } else {
                switch (e.which) {
                    case 9:
                        //tab
                        if ($focusedItem.hasClass("ws-heading")) {
                            e.preventDefault();
                            $focusedItem.parent().siblings(".ws-nav__sub-section-links-wrapper").find("a.ws-nav__section-link").first().focus();
                            return;
                        } else if ($focusedItem.parent("li").is($focusedItem.closest("ul").children().last())) {
                            e.preventDefault();
                            $focusedItem.closest(".ws-nav__mobile-page-inner").first().find("a.ws-action-link").first().focus();
                            return;
                        } else if ($focusedItem.hasClass("ws-action-link") && !$focusedItem.hasClass("ws-nav__mobile-back-link")) {
                            e.preventDefault();
                            $('.ws-nav__utility-nav-home').focus();
                            return;
                        }

                        break;
                    case 13:
                        //enter
                        if ($focusedItem.hasClass("ws-nav__mobile-back-link")) {
                            var $isPrimary = $focusedItem.parents("li").hasClass("ws-nav__primary-link-wrapper--selected");
                            if ($isPrimary) {
                                $focusedItem.parents("li").children("a").focus();
                                $mobilePrimaryLinks.attr("tabindex", "");
                                $mobileSecondaryLevelLinks.attr("tabindex", -1);
                                $mobileThirdLevelLinks.attr("tabindex", -1);
                            }

                            clickLink($focusedItem);
                            return;
                        }

                        var $linksUnderParent = $focusedItem.siblings().find('a.ws-nav__third-level-link, button.ws-nav__third-level-link');
                        $linksUnderParent.attr("tabindex", "");
                        $mobilePrimaryLinks.attr("tabindex", -1);
                        $mobileSecondaryLevelLinks.attr("tabindex", -1);

                        clickLink($focusedItem);
                        break;
                    default:
                        break;
                }
            }
        }
    });

    $mobileThirdLevelLinks.on("keydown", function (e) {
        if (!Modernizr.mq(desktopMq)) {
            var $focusedItem = $(e.currentTarget);
            if (e.shiftKey && e.key === 'Tab') {
                //shift+tab
                if ($focusedItem.parent("li").is($focusedItem.closest("ul").children().first())) {
                    e.preventDefault();
                    $focusedItem.closest(".ws-nav__mobile-page-inner").find("a.ws-heading").first().focus();
                    return;
                } else if ($focusedItem.hasClass("ws-action-link")) {
                    e.preventDefault();
                    $focusedItem.closest(".ws-nav__mobile-page-inner").find("ul").first().children(":last-child").children("a").focus();
                    return;
                }

                return;
            }
            else {
                switch (e.which) {
                    case 9:
                        //tab
                        if ($focusedItem.hasClass("ws-heading")) {
                            e.preventDefault();
                            $focusedItem.parent().siblings(".ws-nav__sub-section-links-container--level_three").find("a.ws-nav__sub-section-link").first().focus();
                            return;
                        } else if ($focusedItem.parent("li").is($focusedItem.closest("ul").children().last())) {
                            e.preventDefault();
                            $focusedItem.closest(".ws-nav__mobile-page-inner").first().find("a.ws-action-link").first().focus();
                            return;
                        } else if ($focusedItem.hasClass("ws-action-link") && !$focusedItem.hasClass("ws-nav__mobile-back-link")) {
                            e.preventDefault();
                            $('.ws-nav__utility-nav-home').focus();
                            return;
                        }

                        break;
                    case 13:
                        //enter
                        if ($focusedItem.hasClass("ws-nav__mobile-back-link")) {
                            $focusedItem.parents("li").children("a").focus();
                            $mobilePrimaryLinks.attr("tabindex", -1);
                            $mobileSecondaryLevelLinks.attr("tabindex", "");
                            $mobileThirdLevelLinks.attr("tabindex", -1);
                        }

                        clickLink($focusedItem);
                        break;
                    default:
                        break;
                }
            }
        }
    });

    if ($body.hasClass('pagemode-edit')) {
        // in Experience Editor mode, we want to disable arrow key navigation so it doesn't interfere with editing
        $touchPrimaryLinks.off('keydown');
        $sectionHeadingLinks.off('keydown');
        $sectionInfoLinks.off('keydown');
        $sectionLinkTags.off('keydown');
        $subSectionLinks.off('keydown');
    }

    /* --- END: HEADER KEYBOARD ACCESSIBILITY --- */

    function mobileOnScreenTransitionEnd(event) {
        // Transitionend events apparently get fired for all children of the target element,
        // in addtion to the element itself. So we need to check that this callback is
        // being fired for the intented target before continuing.
        if (event.target === event.currentTarget) {
            $(event.currentTarget)
                .addClass(mobilePageOnScreenCompleteClass)
                .off(WS.getTransitionEndEventName(), mobileOnScreenTransitionEnd);
        }
    }

    function openMegaMenu($target) {
        $primaryLinks.removeClass(primaryLinkSelectedClass);
        $target.addClass(primaryLinkSelectedClass);
        SiteMask.showDesktopNavMask();

        if (WS.isExperienceEditor()) {
            WS.resetChromes();
        }
    }

    function closeMegaMenu() {
        $primaryLinks.removeClass(primaryLinkSelectedClass);
        SiteMask.hide();
        $document.off('click', clickOutsideMenuHandler);

        if (WS.isExperienceEditor()) {
            WS.resetChromes();
        }
    }

    function clickOutsideMenuHandler(event) {
        if (Modernizr.mq(desktopMq)) {
            var $target = $(event.target);

            if (!$target.closest('.ws-nav').length) {
                closeMegaMenu();
            }
        }
    }
    
    $(".ws-nav__mobile-link--featured").on("click", function (event) {
        // if the featured link should open a dynamic dropdown instead of redirecting.
        var $dynamicDropdownSibling = $(this).siblings(".ws-nav__dynamic-dropdown");
        if ($dynamicDropdownSibling.length) {
            event.preventDefault();
            $dynamicDropdownSibling.toggleClass("ws-nav__dynamic-dropdown--show");
            $(this).parent().toggleClass("ws-nav__mobile-link--featured--open");
        }
    });

    $(".ws-nav__dynamic-dropdown-content__close").on("click", function (event) {
        $(this).closest(".ws-nav__dynamic-dropdown").toggleClass("ws-nav__dynamic-dropdown--show");
        $(".ws-nav__mobile-link--featured").parent().toggleClass("ws-nav__mobile-link--featured--open");
    });

    $(".ws-nav__nav-link--dynamic-dropdown").focus(function () {
        // if the featured link should open a dynamic dropdown instead of redirecting.
        var $dynamicDropdownSibling = $(this).siblings(".ws-nav__dynamic-dropdown");
        if ($dynamicDropdownSibling.length) {
            $dynamicDropdownSibling.toggleClass("ws-nav__dynamic-dropdown--show");
            $(this).parent().toggleClass("ws-nav__mobile-link--featured--open");
        }
    });

    $(".ws-nav__utility-nav-link").focus(function () {
        if (!$(this).parent(".ws-nav__utility-nav-link--desktop-only").length) {
            var $utilityDynamicDropdownLink = $utilityNav.children(".ws-nav__utility-nav-link--desktop-only");
            $utilityDynamicDropdownLink.children(".ws-nav__dynamic-dropdown").removeClass("ws-nav__dynamic-dropdown--show");
            $utilityDynamicDropdownLink.removeClass("ws-nav__mobile-link--featured--open");
        }
    });
}

function initNavOnceReady(readyCallback) {
    if (executed) {
        clearInterval(intervalId);
        return;
    }

    // if the secondary nav is being loaded via ajax, make sure that has completed before initializing the nav JS
    const $mainNav = $('.ws-nav__main');
    const secondaryNavLoadingViaAjax = $mainNav.data('ws-datasource');
    const secondaryNavLoaded = $mainNav.data('ws-datasource-loaded');

    if (!secondaryNavLoadingViaAjax || secondaryNavLoaded) {
        clearInterval(intervalId);
        initNav();
        executed = true;

        if (typeof readyCallback === 'function') {
            readyCallback();
        }
    }
}

function startInitInterval(readyCallback) {
    // only allow the interval to be set up once
    if (!executed && !intervalId) {
        intervalId = setInterval(() => initNavOnceReady(readyCallback), 50);
    }
}

$(function () {
    $(".ws-nav *").one("click mouseover focus", function (event) {
        startInitInterval(function () {
            // if the mobile menu button was clicked (treated as mouseover on mobile) as the event that initializes the nav, we want to open the menu afterwards
            if (event.target === mobileMenuBtn && (event.type === "click" || (event.type === "mouseover" && Modernizr.browsertouch))) {
                toggleMobileMenu(event);
            }
        });
    });

    $(window).one("scroll", startInitInterval);
});
